export function feat(o: any, name: string, defaultValue = false) {
    return !!o && !!o.features && o.features?.includes(name) ? true : defaultValue;
}

export default feat;
